import React from 'react';
import { Card } from 'react-bootstrap';
import { IProductLine2, ProductLineClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { ImageSetter } from '../MaterialEditor/ImageSetter';

export function ProductLineImageSetter(props: {
    onChange: () => void;
    productLine: Readonly<IProductLine2>
	
}) {


    const client = useClient(ProductLineClient);


    async function setImage(f: File) {
        const extension = f.type.split("/")[1];
        await client.setImage(props.productLine.id,
            extension,
            { data: f, fileName: f.name }
        );
        props.onChange();
    }


	return (
        <Card>
            <Card.Body>
                <Card.Title>
                    Product Line Image
                </Card.Title>
                <Card.Body>
                    <ImageSetter url={props.productLine.imageUrl}
                        onSet={setImage}
                    />
                </Card.Body>
            </Card.Body>
        </Card>
	);
}
